import React, { useState, useContext } from 'react';
import Layout from '../../../../common/Layout';
import ChallengeTemplate from '../ChallengeTemplate';
import { useChallengeInstance } from '../../../../hooks/useChallengeInstance';
import { useEvaluateStep } from '../../../../hooks/useEvaluateStep';
import LoadingAnimation from "../../../../common/components/base/LoadingAnimation";
import Swal from 'sweetalert2';
import ChallengeContext from '../../../../store/challenge-context';

const AppraiseResult = (props) => {
  const challengeId = props.match.params.id;

  // Hook per recuperare i dati della challenge instance
  const { data, isFetching: isLoading, error } = useChallengeInstance(challengeId);
  
  // State per tracciare lo status dinamico della challenge (aggiornato ad ogni step)
  const [challengeStatus, setChallengeStatus] = useState(null);
  
  // Hook per valutare lo step
  const evaluateStepMutation = useEvaluateStep();
  const { challengeOrigineRoute } = useContext(ChallengeContext);

  const coreSubmit = async (parameter, validationField, challengeToDo, stepTime, status, isValidationAction = false, isRevokeAction = false) => {
    const action = {
      actionNeeded: 'click',
      target: 'button',
      parameter: parameter,
      validationField: validationField,
      stepTime: stepTime,
      ...(status !== undefined && status !== null && { status })
    };
    
    try {
      const res = await evaluateStepMutation.mutateAsync({
        challengeId,
        action,
        challengeToDo
      });
      
      let value = res.challengeStepEvaluator.targetLocation || '';
      
      // Aggiorna lo status dinamico se presente nella risposta
      if (res.challengeStepEvaluator.status) {
        setChallengeStatus(res.challengeStepEvaluator.status);
      }
      
      // Mostra Swal solo per richiesta di validazione
      if (isValidationAction) {
        Swal.fire({
          type: 'success',
          title: 'Richiesta di Validazione inoltrata con successo',
          showConfirmButton: false,
          timer: 2000
        });
        
        setTimeout(() => {
          if (challengeOrigineRoute) {
            props.history.push(challengeOrigineRoute);
          }
        }, 2000); 
      }
      
      // Se è revoca, NON navigare da nessuna parte
      if (isRevokeAction) {
        // Non fare nulla, rimani sulla pagina
        return;
      }
      
      // Per operazioni normali (non validazione e non revoca), naviga al targetLocation
      if (value !== '' && !isValidationAction) {
        await props.history.push(value + challengeId);
      }
    } catch (error) {
      console.error('Error evaluating step:', error);
    }
  };

  const submit = (parameter, validationField, challengeToDo, stepTime, status, isValidationAction = false, isRevokeAction = false) => {
    // Restituisci sempre la Promise da coreSubmit
    return coreSubmit(parameter, validationField, challengeToDo, stepTime, status, isValidationAction, isRevokeAction);
  };

  // Gestione loading
  if (isLoading) return <LoadingAnimation />;
  
  // Gestione errore
  if (error) return `Error! ${error.message}`;
  
  // Gestione dati
  if (data?.challengeInstance) {
    // Determina lo status corrente: usa challengeStatus se disponibile, altrimenti quello iniziale dalla instance
    const currentStatus = challengeStatus ?? data.challengeInstance.status;
    
    return (
      <Layout
        name={"Challenge"}
        hideMenu={true}
        isValidation={data.challengeInstance.isValidation}
      >
        <ChallengeTemplate
          history={props.history}
          id={props.match.id}
          type={data.challengeInstance.challengeType}
          currentStep={data.challengeInstance.currentStep}
          submit={submit}
          onChange={() => {}} // Placeholder per onChange se necessario
          isSubmitting={evaluateStepMutation.isPending}
          challengeStatus={currentStatus}  // ← Passa SOLO lo status dinamico (blockedSteps viene da challenge definition)
        />
      </Layout>
    );
  }

  return null;
};

export default AppraiseResult;
